// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
/** @jsx jsx */
/** @jsxRuntime classic */

import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';

const containerStyle = css`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  border: 1px solid #1149835b;
  border-radius: 10px;
  padding: 3rem 40px;

  @media (max-width: 56.25rem) {
   padding: 1.2rem;
  }

`;

const ContainerWithCounter = styled.div`
  background: #e3edf3;
  border-radius: 6px;
  padding: 2.5rem 7%;
  position: relative;

  &:before {
    content: "${(props) => props.counter}";
    background: ${(props) => props.theme.primaryColor};
    height: 30px;
    width: 30px;
    position: absolute;
    border-radius: 50%;
    top: -12px;
    left: -15px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    font-weight: 500;
  }
`;

const StyledParagraph = styled.p`
  color: ${(props) => props.theme.primaryColor};
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5;
`;

const StyledTextHeading = styled.p`
  color: #000000af;
  font-weight: 500;
  font-size: 0.9rem;
  line-height: 1.3;
  margin-bottom: 0.3rem;
`;

const StyledInfoContainer = styled.div`
  margin-bottom: 2.2rem;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const BankTransfer = ({ dataObject }) => {
  const {
    parameters: { 'bank-details': bankFields },
  } = dataObject;
  return (
    <div css={containerStyle}>
      <div>
        <ContainerWithCounter counter="1">
          <StyledParagraph>
            Connect to your online banking or call your bank & transfer the
            sending amount to the bank account given below
          </StyledParagraph>
        </ContainerWithCounter>

        <ContainerWithCounter
          counter="2"
          css={css`
            margin-top: 3rem;
          `}
        >
          <StyledParagraph>
            Transfer the amount due using this information
          </StyledParagraph>

          <div
            css={css`
              background: #f5f9fb;
              border-radius: 6px;
              padding: 2.5rem 2rem;
              margin-top: 1rem;
            `}
          >
            {Object.entries(bankFields).map(([fieldKey, fieldValue]) => (
              <StyledInfoContainer key={fieldKey}>
                <StyledTextHeading>{fieldKey}</StyledTextHeading>
                <StyledParagraph>{fieldValue}</StyledParagraph>
              </StyledInfoContainer>
            ))}
          </div>
        </ContainerWithCounter>
      </div>
    </div>
  );
};

export default BankTransfer;
